import SailsService from './sails.service';
export default class ResourceListService extends SailsService {
  constructor($http) {
    'ngInject';

    super('resourceList');
    this.store = super.model();
    this.create = super.post;
    this.update = super.put;
    this.destroy = super.delete;
    this.$http = $http;
  }

  getResourceLists() {
    return this.get().catch((error) => {
      console.error(error);
      return this.$q.reject(error.data);
    });
  }

  getResourcesForList(id, limit, skip, sort, filter) {
    return this.get([id, 'resources'], {
      where: JSON.stringify(filter),
      limit,
      skip,
      sort,
    }).catch((error) => {
      console.error(error);
      return this.$q.reject(error.data);
    });
  }


  getResourcesExport(resourcelistId) {
    const url = `${window.appConfig.apiBaseUrl}/resourcelist/${resourcelistId}/resource/export/file`;
    return this.$http.get(url)
      .catch(error => this.$q.reject(error.data));
  }
}
